import React from 'react';
import { Option as OptionType } from 'react-select/src/filters';
import Tooltip from '@cld/tooltip';
import { useMixin } from '@cld/component-theme';
import { Text } from '@cld/item';
import { withListItemLayout } from '../withListItemLayout';
import { theme } from '../theme';

export const Option = withListItemLayout<OptionType>((option, layoutProps, selectProps) => {
  const label = selectProps.getOptionLabel?.(option) || option.label;
  return (
    <Text {...layoutProps}>
      <Tooltip title={label} placement={useMixin(theme.tooltip.placement)} maxWidth={useMixin(theme.tooltip.maxWidth)}>
        <Tooltip.OverflowTrigger>{label}</Tooltip.OverflowTrigger>
      </Tooltip>
    </Text>
  );
});
